import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-campaign-standard-event-reference"
    }}>{`Adobe Campaign Standard event reference`}</h1>
    <h2 {...{
      "id": "events-handled"
    }}>{`Events handled`}</h2>
    <p>{`The following events are handled by the Adobe Campaign Standard extension:`}</p>
    <h3 {...{
      "id": "campaign-request"
    }}>{`Campaign request`}</h3>
    <p>{`The Campaign request event is dispatched from the Event Hub when a Campaign rule is found to be true. For example, after the user launches the app, the "User has launched the app" rule will be true. A triggered consequences event is dispatched, which contains the data of the displayed local, alert, or full-screen message.`}</p>
    <h4 {...{
      "id": "payload-definition"
    }}>{`Payload definition`}</h4>
    <p>{`The following key-value pairs are present in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`triggeredconsequence`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The triggered Campaign rule consequence.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "example"
    }}>{`Example`}</h4>
    <p>{`The following example shows triggered consequence data.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
  "triggeredconsequence": {
    "assetsPath": "assets/path/",
    "id": "123",
    "detail": {
      "template": "local",
      "wait": 0,
      "userData": {
        "deliveryId": "123abc",
        "broadlogId": "456edf"
      },
      "title": "local example",
      "content": "local example text"
    },
    "type": "iam"
  }
}
`}</code></pre>
    <h3 {...{
      "id": "configuration-response"
    }}>{`Configuration response`}</h3>
    <p>{`The data property in the configuration response event is used by each extension to modify its current settings. Each extension is responsible for parsing the relevant part of the data property.`}</p>
    <h4 {...{
      "id": "payload-definition-1"
    }}>{`Payload definition`}</h4>
    <p>{`The following key value pairs are supported for Adobe Campaign Standard extension when reading from the configuration event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`__dev__campaign.server`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the endpoint URL for the development environment in the Adobe Campaign Standard instance.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`__dev__campaign.pkey`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the identifier for a mobile app that was configured in the development environment in Adobe Campaign Standard.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`__stage__campaign.server`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the endpoint URL for the staging environment in the Adobe Campaign Standard instance.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`__stage__campaign.pkey`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the identifier for a mobile app that was configured in the staging environment in Adobe Campaign Standard.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.server`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the endpoint URL for the production environment in the Adobe Campaign Standard instance.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.pkey`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the identifier for a mobile app that was configured in the production environment in Adobe Campaign Standard.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.mcias`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the in-app messaging service URL endpoint.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.timeout`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the amount of time to wait for a response from the in-app messaging service.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`global.privacy`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the mobile privacy status settings.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.registrationDelay`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the number of days to delay the sending of the next Adobe Campaign Standard registration request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`campaign.registrationPaused`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the Adobe Campaign Standard registration request paused status.`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`After `}<inlineCode parentName="p">{`global.privacy`}</inlineCode>{` is changed to `}<strong parentName="p">{`optout`}</strong>{`, the linkage fields are reset. All downloaded messages and rules are erased, and no tracking request can leave the device.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`The configuration setting to pause registration requests is provided for specific use cases only. The use of this configuration setting should be avoided when possible.`}</p>
    <h4 {...{
      "id": "example-1"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "global.privacy":"optedin",
    "campaign.timeout":1,
    "campaign.mcias":"mcias-va7.cloud.adobe.io/mcias",
    "__dev__campaign.pkey":"",
    "__stage__campaign.pkey":"",
    "campaign.pkey":"",
    "__dev__campaign.server":"mcias.campaign-demo.adobe.com",
    "__stage__campaign.server":"mcias.campaign-demo.adobe.com",
    "campaign.server":"mcias.campaign-demo.adobe.com"
}
`}</code></pre>
    <h3 {...{
      "id": "request-identity"
    }}>{`Request identity`}</h3>
    <p>{`The request identity event is dispatched by the API to set linkageFields, which sets the linkage fields. It is used to download personalized in-app messages.`}</p>
    <h4 {...{
      "id": "payload-definition-2"
    }}>{`Payload definition`}</h4>
    <p>{`The following key-value pairs are supported in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`linkagefields`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This map contains at least one of the linkage fields that are used to personally identify the logged in user.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "example-2"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{ 
    "linkagefields": 
    { 
        "firstName":"john", 
        "lastName":"doe", 
        "age":30
    }
}
`}</code></pre>
    <h3 {...{
      "id": "request-reset"
    }}>{`Request reset`}</h3>
    <p>{`The request reset event is dispatched when users no longer want to use personalized in-app messages. After this event is received, Adobe Campaign Standard deletes all personalized messages and will only download generic messages.`}</p>
    <h4 {...{
      "id": "data-payload"
    }}>{`Data payload`}</h4>
    <p>{`This event has no event data.`}</p>
    <h3 {...{
      "id": "lifecycle-response"
    }}>{`Lifecycle response`}</h3>
    <p>{`The lifecycle response event is a response from the Lifecycle extension that notifies a client or extension about lifecycle context data in which the client or extension might be interested. The event is generated by the Lifecycle extension, and the API is called after a lifecycle start, stop, or pause.`}</p>
    <h4 {...{
      "id": "payload-definition-3"
    }}>{`Payload definition`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lifecyclecontextdata`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The map that contains the stored lifecycle metrics.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "example-3"
    }}>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{    "lifecyclecontextdata": 
    {
        "installdate":"22/05/2014",        
        "hourofday":6,        
        "dayofweek":2,        
        "osversion":"iOS 12.3",        
        "appID":"contextDataValue",        
        "resolution":"600x1345",        
        "devicename":"iPhoneX",        
        "launchevent":"LaunchEvent",        
        "prevsessionlength":345,        
        "locale":"en-US",        
        "runmode":"Application",        
        "launches":42    
    },    
    "starttimestampmillis" :44,    
    "maxsessionlength":22
}
`}</code></pre>
    <h3 {...{
      "id": "generic-data-os"
    }}>{`Generic data OS`}</h3>
    <p>{`The generic data OS event is dispatched by the Core extension to the Event Hub when the `}<inlineCode parentName="p">{`collectMessageInfo`}</inlineCode>{` API is invoked by the app developer to track local and push notification interactions.`}</p>
    <h4 {...{
      "id": "payload-definition-4"
    }}>{`Payload definition`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`deliveryId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The string that contains the delivery ID of the message for which there were interactions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`action`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The string that contains the message interaction ID.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`broadlogId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The string that contains the broadlog ID of the message for which there were interactions.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "event-data-example"
    }}>{`Event data example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "deliveryId": "1442de4",
    "action": "2",
    "broadlogId": "h1c1380"
}
`}</code></pre>
    <h2 {...{
      "id": "events-dispatched"
    }}>{`Events dispatched`}</h2>
    <p>{`The following events are dispatched by the Campaign Standard extension:`}</p>
    <h3 {...{
      "id": "campaign-response"
    }}>{`Campaign response`}</h3>
    <p>{`The Campaign response event is a response from the Adobe Campaign Standard extension and contains the message interaction details: Viewed, Triggered, or Clicked.`}</p>
    <h4 {...{
      "id": "event-details"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.campaign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.responseContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "payload-definition-5"
    }}>{`Payload definition`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.message.id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The message ID of the message that was triggered.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.message.triggered`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String ("1")`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A flag that specifies a message triggered event. Only one type of message interaction exists in each Campaign response content event.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.message.viewed`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String ("1")`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A flag that specifies a message viewed event.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.message.clicked`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String ("1")`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A flag that specifies a message clicked event.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "event-data-example-1"
    }}>{`Event data example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{ "a.message.id": "12345678", "a.message.triggered": "1" }
{ "a.message.id": "12345678", "a.message.viewed": "1" }
{ "a.message.id": "12345678", "a.message.clicked": "1" }
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      